import { isEqual } from 'lodash';

import { Entity } from '../../types/Entity';
import { EntityResolvers } from '../../types/EntityResolvers';
import { Nullable } from '../../types/Nullable';
import { User } from '../../types/User';
import { CommentFilters, CommentId, ContextEntityType } from './types';

export const defaultFilters: CommentFilters = {
  order: 'chronological',
  source: 'all',
  status: 'open',
  flags: [],
};

export const testIsTargetComment = (
  referenceCommentId: CommentId,
  targetCommentId?: Nullable<CommentId>,
) => referenceCommentId === targetCommentId;

export const testIsViewerUser = (user: User, viewer: User) => {
  return user.id === viewer.id;
};

export const resolveHighlightEntity = (
  highlightEntity: Entity<ContextEntityType> | undefined,
  entityResolvers: EntityResolvers,
) => {
  return highlightEntity
    ? entityResolvers?.highlight?.(highlightEntity as Entity<'highlight'>)
    : null;
};

export const getHighlightFromContext = (
  enitites: Entity<ContextEntityType>[],
) => {
  return enitites.find((entity) =>
    (['highlight', 'editor_highlight'] as ContextEntityType[]).includes(
      entity.type,
    ),
  );
};

export const testIsFiltersUpdated = (filters: CommentFilters) =>
  isEqual(filters, defaultFilters);
